import React, { useReducer } from 'react'
import ConsultaTicketContext from './ConsultaTicketContext'

const initialState = {
  numeroTicket: '',
  verificacion: '',
  appColor: 'DE1721',
  appFormato: '',
  appLogo: ''
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
const ConsultaReducer = (state: any = initialState, action: any) => {
  const newState = {
    ...state,
    ...action
  }

  // Store in localStorage with a different key than the main app state
  window.localStorage.setItem('consulta', JSON.stringify(newState))
  return newState
}

interface ConsultaContextStateProps {
  children: React.ReactNode;
}

const ConsultaContextState: React.FC<ConsultaContextStateProps> = ({ children }) => {
  // Try to load initial state from localStorage
  let loadedState = initialState
  try {
    const savedState = window.localStorage.getItem('consulta')
    if (savedState) {
      loadedState = JSON.parse(savedState)
    }
  } catch (error) {
    console.error('Error loading consulta state from localStorage', error)
  }

  const [stateConsultaReducer, dispatchConsultaReducer] = useReducer(
    ConsultaReducer,
    loadedState
  )

  const handleInput = (evt: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    switch (evt.target.type) {
    case 'checkbox':
      const chbox = evt.target as HTMLInputElement
      updateField(chbox.name, chbox.checked ? chbox.value : '')
      break
    default:
      const name = evt.target.name
      const newValue = evt.target.value
      updateField(name, newValue)
    }
  }

  const updateField = (name: string, newValue: string) => {
    dispatchConsultaReducer({ [name]: newValue })
  }

  return (
    <ConsultaTicketContext.Provider
      value={{
        consulta: stateConsultaReducer,
        handleInput,
        updateField
      }}
    >
      {children}
    </ConsultaTicketContext.Provider>
  )
}

export default ConsultaContextState
